import { useScheduledPost } from "@circle-react/components/QuickPostV3/hooks/useScheduledPost";
import { formattedDateTime } from "@circle-react/helpers/dateTimeHelpers/formattedDateTime";
import { POST_STATUS_DRAFT } from "@circle-react/helpers/postHelpers";
import { Button } from "@circleco/compass/components/Button";
import { Icon } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";
import { useState } from "react";

import { t } from "@/i18n-js/instance";
import { ScheduleDateTimePickerPopover } from "@/react/components/PostsCompass/ScheduleDateTimePickerPopover";

export const ScheduledIndicator = () => {
  const [isSchedulePickerOpen, setIsSchedulePickerOpen] = useState(false);
  const {
    canSchedule,
    disabledDays,
    isScheduled,
    onScheduleDateSave,
    scheduledAt,
    setStatus,
    updatePublishedAt,
  } = useScheduledPost();

  if (!isScheduled || !scheduledAt) {
    return null;
  }

  const revertToDraftState = () => {
    updatePublishedAt(null);
    setStatus(POST_STATUS_DRAFT);
  };

  const formattedPublishedAt = formattedDateTime({
    dateTime: scheduledAt,
    format: "short_date_at_short_time",
  });

  return (
    <div className="border-primary bg-secondary flex items-center justify-between gap-3 border-b px-6 py-3">
      <div className="flex min-w-0 items-center gap-2">
        <Icon name="clock-dash" size="sm" />
        <Typography variant="label-sm" color="primary" className="truncate">
          {t("quick_post_v2.scheduled_for", { date: formattedPublishedAt })}
        </Typography>
      </div>
      {canSchedule && (
        <div className="flex shrink-0 items-center gap-2">
          <ScheduleDateTimePickerPopover
            disabledDays={disabledDays}
            onOpenChange={setIsSchedulePickerOpen}
            onSave={onScheduleDateSave}
            open={isSchedulePickerOpen}
            side="bottom"
            trigger={
              <Button size="sm" type="button" variant="outline">
                {t("edit")}
              </Button>
            }
            value={scheduledAt}
          />
          <Button
            onClick={revertToDraftState}
            size="sm"
            type="button"
            variant="primary"
          >
            {t("delete")}
          </Button>
        </div>
      )}
    </div>
  );
};
